import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from 'react-redux';
import { matchPath } from "react-router-dom";
import MemHub from "./components/memHub";
import store from './redux/store';
import "./index.css";

const rewriteUrlToSelectedTab = () => {
    const href = localStorage.getItem('href');
    console.log("href:", href);

    if (href) {
        let isVotingTab = false;
        if (matchPath('/voting', document.location.pathname) || matchPath('/voting/:activityId', document.location.pathname)) {
            localStorage.setItem('fromVoting', '1');
            isVotingTab = true;
        }

        let isWalletTab = false;
        if (matchPath('/wallet', document.location.pathname)) {
            localStorage.setItem('fromWallet', '1');
            isWalletTab = true;
        }

        if (!isVotingTab || !isWalletTab) {
            const isLoggedIn = localStorage.getItem('isLoggedIn');
            console.log("isLoggedIn:", isLoggedIn);

            if (!isLoggedIn || isLoggedIn === '0') {
                let newUrl = href;
                console.log("newUrl:", newUrl);
                window.history.replaceState({}, null, newUrl);
            }
        }
    }
};

rewriteUrlToSelectedTab();

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
    <Provider store={store}>
        <MemHub />
    </Provider>
);
